import { breakpoints, theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const StyledHeader = styled.div`
  @media (min-width: ${breakpoints.md}) {
    width: 100%;
  }
`;

export const H1 = styled.h1`
  color: ${theme.color.text.primary};
  font-weight: 300;
  padding: 0;
  text-transform: none;
  margin: 1rem 0 0.625rem;

  font-size: 1.125rem !important;
  line-height: 2rem !important;
  text-align: left;

  @media (min-width: ${breakpoints.sm}) {
    margin: 2.125rem 0 1.125rem;
    font-size: 1.5rem !important;
  }

  margin: 0 !important;
`;

export const BrandExtraLine = styled.a`
  margin-right: 0.3rem;

  &:hover {
    text-decoration: underline;
  }

  margin-right: 0.25rem;
  color: ${theme.color.text.secondary};
  font-size: 1rem;
  color: ${theme.color.text.primary};
  font-size: 1.125rem;
  @media (min-width: ${breakpoints.sm}) {
    font-size: 1.5rem;
  }
  @media (min-width: ${breakpoints.md}) {
    font-size: 1rem;
  }
`;

export const ProductNameWrapper = styled.span`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  align-items: center;

  @media (min-width: ${breakpoints.md}) {
    flex-direction: row;
  }
`;

export const Span = styled.span`
  font-weight: bold;

  display: block;
  font-size: 1rem;
  margin-top: 0rem;
  line-height: 1.5rem;
`;

export const Description = styled.span`
  ${theme.typography.bodyRegular};
  color: ${theme.color.text.secondary};
  margin-bottom: 0.5rem;
  display: block;

  @media (min-width: ${breakpoints.md}) {
    margin-top: 0.25rem;
  }
`;

export const SubName = styled.span`
  display: block;
  font-size: 0.875rem;
  font-weight: 300;

  @media (min-width: ${breakpoints.sm}) {
    line-height: 2rem;
    font-size: 1.1rem;
  }
`;

export const ReviewsAnchor = styled.a`
  cursor: pointer;
  text-decoration: none;
`;

export const Wrapper = styled.div`
  height: 1.125rem;
  position: relative;
`;

export const RatingWrapper = styled.div`
  svg {
    vertical-align: initial !important;
  }
  display: flex;
  align-items: center;
  gap: 2px;
`;

export const AvgRating = styled.span`
  ${theme.typography.labelSmall}
  color: ${theme.color.text.primary};
  margin-left: 2px;
`;

export const RatingsCount = styled.span`
  ${theme.typography.labelSmall400}
  color: ${theme.color.text.secondary};
  > span {
    text-decoration: underline;
  }
  &:hover > span {
    text-decoration: none;
  }
`;
